// Allowing users to download image files from the gallery/fancybox
export function downloadImage(e) {
    e.stopImmediatePropagation();
}